import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { PROGRAM_STATUSES } from "@/domain/programs.interface";

const programValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup
      .string()
      .required("This field is required")
      .min(2, t("validations.min_length", { count: 2 }))
      .max(120, t("validations.max_length", { count: 120 })),
    status: yup
      .string()
      .required("This field is required")
      .oneOf([...PROGRAM_STATUSES], "Invalid status"),
    eventName: yup.string().default(""),
    orgUnitId: yup
      .array()
      .of(yup.string().required())
      .min(1, "Select at least one org unit")
      .required("This field is required")
      .default([]),
    requiresCaseNumber: yup.boolean().default(false),
    maxParticipants: yup
      .number()
      .typeError("Max participants must be a number")
      .transform((value, original) =>
        original === "" || original === null || original === undefined
          ? undefined
          : value
      )
      .min(0, "Max participants must be 0 or greater")
      .nullable()
      .optional(),
    starDate: yup.string().default(""),
    endDate: yup
      .string()
      .default("")
      .test(
        "end-after-start",
        "End date must be on or after the start date",
        function (value) {
          const { starDate } = this.parent;
          if (!value || !starDate) return true;
          return new Date(value).getTime() >= new Date(starDate).getTime();
        }
      ),
  });

export type ProgramFormData = InferType<
  ReturnType<typeof programValidationSchema>
>;

export default programValidationSchema;
